
const ReservationActions = {
  RSVP_ADD_STARTED: 'RSVP_ADD_STARTED',
  RSVP_ADD_COMPLETED: 'RSVP_ADD_COMPLETED',
  RSVP_REQUEST_FAILED: 'RSVP_REQUEST_FAILED'
};

const ReservationEndpoints = {
  add: '/rsvp/add'
};

const sendReservation = (data) => {
  return async dispatch => {
    dispatch({ type: ReservationActions.RSVP_ADD_STARTED });
    try {
      // eslint-disable-next-line no-undef
      await fetch(ReservationEndpoints.add, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(data)
      });
      dispatch({ type: ReservationActions.RSVP_ADD_COMPLETED, data });
    } catch (ex) {
      dispatch(requestFailed(ex));
    }
  };
};

const requestFailed = errorMessage => {
  return {
    type: ReservationActions.RSVP_REQUEST_FAILED,
    error: errorMessage
  };
};

export {
  ReservationActions,
  sendReservation
};
